import MultiQueryPageLoader from '@/app/common/components/PageLoader/MultiQueryPageLoader'
import { selectFamilyApplication } from '@/storage/applications/familyApplicationSlice'
import { selectProgramID } from '@/storage/program_settings/programSettingsSlice'
import { MutationStatus } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import {
  useGetExpenseCategories,
  useStudentPurses,
} from '../../api/usePaymentProviders'
import { ProviderPaymentDetails } from '../../create_provider_request_form'
import ReviewSummary from './_components/review_summary'
import { useGetPaymentFees } from '@/apis/payments/hooks/useGetPaymentFees'

type Props = {
  paymentDetails: ProviderPaymentDetails
  mutationStatus: MutationStatus,
  onSubmit: () => void
}

export default function ReviewProviderPage(props: Props) {
  const { paymentDetails, mutationStatus, onSubmit } = props
  const application = useSelector(selectFamilyApplication)
  const programId = useSelector(selectProgramID)

  const expensesQuery = useGetExpenseCategories({
    pay_provider: 1,
  })

  const purses = useStudentPurses({
    application_id: application.application_id,
    program_id: programId,
  })

  const paymentFeeQuery = useGetPaymentFees({
    base_amount: paymentDetails.amount,
    program_id: programId,
  })

  return (
    <MultiQueryPageLoader
      queries={[expensesQuery, purses, paymentFeeQuery] as const}
    >
      {([expensesData, apiPurses, paymentFees]) => {
        return (
          <ReviewSummary
            paymentFees={paymentFees}
            apiPurses={apiPurses}
            mutationStatus={mutationStatus}
            onSubmit={onSubmit}
            paymentDetails={paymentDetails}
            expenses={expensesData}
          />
        )
      }}
    </MultiQueryPageLoader>
  )
}
